import { SourcingChannelStatus, SourcingService } from 'api-clients/monolith';

import { DateRangeFilter } from '@/contexts/table-context';

import { campaignsDateParams } from './campaigns-date-params';

type CampaignsQueryParams = {
  page?: number;
  perPage?: number;
  search?: string;
  sortBy?: string;
  sortDir?: 'asc' | 'desc';
  channelIds?: string[];
  statuses?: string[];
  positionIds?: string[];
  locationIds?: string[];
  brandIds?: string[];
  dateRange?: DateRangeFilter;
  /** Whether the account counts metrics in calendar days at each opening. */
  localDays?: boolean;
};

/**
 * The openings[] filter is intentionally omitted — no UI in the Filters bar
 * surfaces it today.
 */
export function getCampaigns(params: CampaignsQueryParams) {
  const dates = campaignsDateParams(
    params.dateRange,
    params.localDays ?? false,
  );
  return SourcingService.getInternalApiSourcingCampaigns(
    dates.preset,
    dates.startDate,
    dates.endDate,
    params.channelIds,
    params.statuses as SourcingChannelStatus[] | undefined,
    params.positionIds,
    params.locationIds,
    params.brandIds,
    undefined,
    params.search,
    params.page,
    params.perPage,
    params.sortBy,
    params.sortDir,
  );
}
